export default __webpack_public_path__ + "static/media/leftJumer.df5d2e6a.png";